import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as NoPainDefault } from '../../assets/smileys/no-pain-default.svg';
import { ReactComponent as NoPainSelected } from '../../assets/smileys/no-pain-selected.svg';
import { ReactComponent as NoPainUnselected } from '../../assets/smileys/no-pain-unselected.svg';
import { ReactComponent as HurtsLittleDefault } from '../../assets/smileys/hurts-little-default.svg';
import { ReactComponent as HurtsLittleSelected } from '../../assets/smileys/hurts-little-selected.svg';
import { ReactComponent as HurtsLittleUnselected } from '../../assets/smileys/hurts-little-unselected.svg';
import { ReactComponent as HurtsLittleMoreDefault } from '../../assets/smileys/hurts-little-more-default.svg';
import { ReactComponent as HurtsLittleMoreSelected } from '../../assets/smileys/hurts-little-more-selected.svg';
import { ReactComponent as HurtsLittleMoreUnselected } from '../../assets/smileys/hurts-little-more-unselected.svg';
import { ReactComponent as HurtsEvenMoreDefault } from '../../assets/smileys/hurts-even-more-default.svg';
import { ReactComponent as HurtsEvenMoreSelected } from '../../assets/smileys/hurts-even-more-selected.svg';
import { ReactComponent as HurtsEvenMoreUnselected } from '../../assets/smileys/hurts-even-more-unselected.svg';
import { ReactComponent as HurtsWholeLotDefault } from '../../assets/smileys/hurts-whole-lot-default.svg';
import { ReactComponent as HurtsWholeLotSelected } from '../../assets/smileys/hurts-whole-lot-selected.svg';
import { ReactComponent as HurtsWholeLotUnselected } from '../../assets/smileys/hurts-whole-lot-unselected.svg';
import { ReactComponent as HurtsWorstDefault } from '../../assets/smileys/hurts-worst-default.svg';
import { ReactComponent as HurtsWorstSelected } from '../../assets/smileys/hurts-worst-selected.svg';
import { ReactComponent as HurtsWorstUnselected } from '../../assets/smileys/hurts-worst-unselected.svg';

const iconRegistry = {
  'no-pain': { default: NoPainDefault, selected: NoPainSelected, unselected: NoPainUnselected },
  'hurts-little': { default: HurtsLittleDefault, selected: HurtsLittleSelected, unselected: HurtsLittleUnselected },
  'hurts-little-more': { default: HurtsLittleMoreDefault, selected: HurtsLittleMoreSelected, unselected: HurtsLittleMoreUnselected },
  'hurts-even-more': { default: HurtsEvenMoreDefault, selected: HurtsEvenMoreSelected, unselected: HurtsEvenMoreUnselected },
  'hurts-whole-lot': { default: HurtsWholeLotDefault, selected: HurtsWholeLotSelected, unselected: HurtsWholeLotUnselected },
  'hurts-worst': { default: HurtsWorstDefault, selected: HurtsWorstSelected, unselected: HurtsWorstUnselected },
};

const SmileyIcon = ({ variant, state, ...rest }) => {
  const iconSet = iconRegistry[variant];

  if (!iconSet) {
    return null;
  }

  const IconComponent = iconSet[state];

  return <IconComponent {...rest} />;
};

SmileyIcon.propTypes = {
  variant: PropTypes.oneOf(Object.keys(iconRegistry)).isRequired,
  state: PropTypes.oneOf(['default', 'selected', 'unselected']),
};

SmileyIcon.defaultProps = {
  state: 'default',
};

export default SmileyIcon;
